import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, [
    'status',
    'index',
    'locationIndex',
    'type',
  ]);
  const modifyDepartment = `modifyDepartment(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyDepartment} {
      id
    }
  }
`;
};
